import {useCatalog} from "../../store/catalog";
import {useCategories} from "../../store/categories";
import {useMemo} from "@wordpress/element";

export function Breadcrumbs() {
    const {filterValues} = useCatalog();
    const {tree} = useCategories();
    const selectedCategory = filterValues?.categories;

    const crumbs = useMemo(() => {
        if (!selectedCategory || !tree) return [];

        const findChainById = (nodes, id, chain = []) => {
            if (!nodes) return null;
            for (const node of nodes) {
                const nextChain = [...chain, node];
                if (node.id === id) return nextChain;
                if (node.subcategories?.length) {
                    const found = findChainById(node.subcategories, id, nextChain);
                    if (found) return found;
                }
            }
            return null;
        };

        const chain = findChainById(tree, selectedCategory.id);
        if (!chain) return [];

        return chain.map((cat, i) => {
            const ancestors = chain.slice(0, i).map(n => n.slug.split('/')[0]);
            const slug = [...ancestors, cat.slug].join('/');
            return {...cat, slug};
        });

    }, [selectedCategory, tree]);

    return (
        <div
            data-block-name="woocommerce/breadcrumbs"
            className="woocommerce wp-block-breadcrumbs wc-block-breadcrumbs alignwide has-font-size has-small-font-size"
        >
            <nav className="woocommerce-breadcrumb" aria-label="Breadcrumb">
                <a href={window.location.origin}>Home</a>

                {crumbs.map((cat, i) => {
                    const isLast = i === crumbs.length - 1;
                    return (
                        <>
                            &nbsp;/&nbsp;
                            <span key={cat.id}>
                                {isLast ? (
                                    cat.name
                                ) : (
                                    <a href={`${window.location.origin}/product-category/${cat.slug}/`}>
                                        {cat.name}
                                    </a>
                                )}
                            </span>
                        </>
                    );
                })}
            </nav>
        </div>
    );
}